// extracted by mini-css-extract-plugin
module.exports = {"paper":"Item_paper__IXdm1","header":"Item_header__2HN1H","logo":"Item_logo__3R1XM","link":"Item_link__3eufT"};